import { useEffect, useRef } from 'react'

import { equals } from 'ramda'

export const usePreviousValue = <V>(value: V): V => {
  const ref = useRef<V>(value)

  useEffect(() => {
    if (!equals(ref.current, value)) {
      ref.current = value
    }
  }, [value])

  return ref.current
}
